// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ef-j";
export var fulfillmentFormRail = "_ef-i";
export var headerTitleRow = "_ef-l";
export var orderDetailsWrapper = "_ef-g";
export var orderLinkTrigger = "_ef-2";
export var paymentInformationGrid = "_ef-q";
export var paymentSummaryColumn = "_ef-r";
export var phoneShipmentPickerButton = "_ef-e";
export var phoneShipmentPickerButtonContent = "_ef-f";
export var phoneShipmentPickerButtonWrapper = "_ef-d";
export var phoneShipmentPickerTrigger = "_ef-c";
export var shipmentContainer = "_ef-k";
export var shipmentDetailsMainPane = "_ef-h";
export var shipmentNavigationCard = "_ef-a";
export var shipmentNavigationEdgeTrigger = "_ef-6";
export var shipmentNavigationRail = "_ef-3";
export var shipmentNavigationRailEnter = "_ef-5";
export var shipmentNavigationRailHeader = "_ef-9";
export var shipmentNavigationRailOverlay = "_ef-4";
export var shipmentNavigationScrim = "_ef-7";
export var shipmentSummaryFact = "_ef-n";
export var shipmentSummaryGrid = "_ef-m";
export var shipmentSummaryMetadataRow = "_ef-o";
export var shipmentSummaryTags = "_ef-p";
export var shipmentWorkspace = "_ef-0";
export var shipmentWorkspaceBodyTablet = "_ef-8";
export var shipmentWorkspaceContent = "_ef-b";
export var shipmentWorkspaceHeader = "_ef-1";